import { Identity } from "./identity.model";
import { UserBirthPlace } from "./user-birthplace.model";
import { UserAddress } from "./user-address.model";
import { UserIdentityDocument } from "./user-iddoc.model";
import { Company } from "./user-company.model";


export class User {

  public username!: string;
  public first_name!: string;
  public last_name!: string;
  public fiscal_code!: string;
  public fiscal_code_card_expiration_date!: Date;
  public fiscal_code_card_id!: string;
  public sex?: string;
  public birth_date?: Date;
  public birthPlace?: UserBirthPlace;
  public legalAddress?: UserAddress;
  public email?: string;
  public pec?: string;
  public phone_number?: string;
  public phone?: string;
  public image?: string;
  public role!: string;
  public identityDocument!: UserIdentityDocument;
  public identities?: Identity[];
  public company?: Company;
  public email_notifications?: boolean;
  public eidup_request: boolean;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

}
